import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useI18n } from "@/context/I18nContext";

export const OptionInfo = ({ image, description, name }) => {
  const { t } = useI18n();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          data-testid="option-info-btn"
          aria-label={t("Infos option")}
          className="inline-flex items-center justify-center text-muted-foreground hover:text-primary transition-colors shrink-0"
        >
          <Info className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64" onClick={(e) => e.stopPropagation()}>
        {name && <div className="font-semibold text-sm mb-2 text-foreground">{t(name)}</div>}
        {image && (
          <img src={image} alt={name} className="w-full h-36 object-cover rounded-md border border-border mb-2 bg-white" data-testid="option-info-img" />
        )}
        <div className="text-xs text-muted-foreground whitespace-pre-line leading-relaxed">
          {description ? t(description) : t("Aucune description pour le moment.")}
        </div>
      </PopoverContent>
    </Popover>
  );
};
